import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Component({
    selector: 'fi-credit-card-date',
    templateUrl: './credit-card-date.component.html',
    styleUrls: ['./credit-card-date.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-credit-card-date' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: CreditCardDateComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: CreditCardDateComponent,
        },
    ],
    standalone: false,
})
export class CreditCardDateComponent extends ControlValueAccessorValidatorBase<Date> implements OnInit {
    date = {
        month: null,
        year: null,
    };
    monthsListData = new DropdownSettingsModelV2<INameIdObj>({
        orderBy: 'Id',
    });
    yearsListData = new DropdownSettingsModelV2<INameIdObj>({
        orderBy: 'Id',
    });

    constructor(
        private injector: Injector,
        private contentLanguages: ContentLanguagesService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.setCreditCardDateDataSets();
        this.Initialize();
    }

    setCreditCardDateDataSets() {
        this.monthsListData.setDataSet(this.contentLanguages.GetMonthShortNames());

        const yearsDataSet: INameIdObj[] = [];
        for (let i = 0; i <= 50; i++) {
            const year: number = new Date().getFullYear() + i;
            yearsDataSet.push({ Id: year, Name: year.toString() });
        }
        this.yearsListData.setDataSet(yearsDataSet);
    }

    private Initialize() {
        this.date.month = this.ngModel ? this.ngModel.getMonth() : null;
        this.date.year = this.ngModel ? this.ngModel.getFullYear() : null;
    }

    writeValue(v: Date) {
        super.writeValue(v);
        this.Initialize();
    }

    doPropagateChanges() {
        this.ngModel.setMonth(this.date.month);
        this.ngModel.setFullYear(this.date.year);
        super.doPropagateChanges();
    }
}
